document.addEventListener('DOMContentLoaded', function() {
  let checkInterval = setInterval(function() {
    if (window.unicornActiveCart === true) {
      window.unicornCloseCart();
      clearInterval(checkInterval);
    }
  }, 1000);
  

});

document.addEventListener('click', function(e) {
  const cartLink = e.target.closest('.header--cart');
  
  if (cartLink) {
    e.preventDefault();
    
   window.unicornOpenCart();
  }
});


document.addEventListener("DOMContentLoaded", (event) => {
document.querySelector('.gallery_action_button')?.addEventListener('click', function() {

    const videoItems = document.querySelector('.video_items');
    let collasbile = videoItems.closest('collapsible-row-element');

    if (collasbile ) {
        collasbile .scrollIntoView({ behavior: 'smooth' });
    }
});
});

 document.addEventListener("cart:updated", ({detail: { items }}) => {
 let buyButtons = document.querySelectorAll('.product-buy-buttons--primary');

if (buyButtons.length > 0) {
  buyButtons.forEach(button => {
    button.setAttribute('aria-busy', 'false');
  });
}

  
});
/*
window.grab_deal = function(event) {
  // Prevent default behavior
  event.preventDefault();
  
  // Find the closest offer container from the button
  const button = event.target;
  const offerContainer = button.closest('.hulkapps-volume-discount-tiers');
  
  if (!offerContainer) {
    console.error('Offer container not found');
    return;
  }
  
  // Get the selected radio button value from the closest container
  const selectedRadio = offerContainer.querySelector('input[name="card_group"]:checked');
  
  if (!selectedRadio) {
    console.error('No option selected');
    return;
  }
  
  const selectedValue = selectedRadio.value;
  console.log('Selected quantity:', selectedValue);
  
  // Find the closest form from the button
  const form = button.closest('form');
  
  if (!form) {
    console.error('Form not found');
    return;
  }
  
  // Find the quantity select element by name
  const quantitySelect = form.querySelector('input[name="quantity"]');
  
  if (!quantitySelect) {
    console.error('Quantity select not found');
    return;
  }
  
  // Update the quantity select value
  quantitySelect.value = selectedValue;
  
  // Trigger change event in case there are listeners
  const changeEvent = new Event('change', { bubbles: true });
  quantitySelect.dispatchEvent(changeEvent);
  
  console.log('Quantity updated to:', selectedValue);
  
  // Optional: Submit the form after updating
  // form.submit();
}
*/
